import { styled } from '@mui/material/styles';

import Box from '@mui/material/Box';

export const ContentContainer = styled(Box)({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '100%',
  maxWidth: 500,
  backgroundColor: '#FFFFFF',
  boxShadow: 24,
  borderRadius: '8px',
  padding: '34px 22px',
});

export const ButtonContainer = styled(Box)({
  display: 'flex',
  justifyContent: 'flex-end',
});
